import type { AttensiFetchError } from './AttensiFetchError'
import { ERROR_NAME } from './constants'

type AttensiFetchErrorProps = {
  message: string
  url: string
} & Partial<AttensiFetchError>

export function createAttensiFetchError({
  message,
  text,
  method = 'GET',
  cause,
  ...props
}: AttensiFetchErrorProps): AttensiFetchError {
  /*
    This is pretty weird and deserves an explanation.
    A normal Error won't serialize to JSON without loosing information, so it can't be easily logged without special treatment.
    The following javascript magic gives us an error that acts like a native Error but it can also be serialized to JSON.
  */
  const prototype = Error(message)
  const error = Object.create(prototype)
  return Object.assign(error, props, {
    name: ERROR_NAME,
    message,
    method,
    cause,
    text,
    json: parseJson(text),
    stack: cause?.stack ?? error.stack,
  })
}

function parseJson(text: string | undefined): undefined | any {
  if (text === undefined) return undefined

  try {
    return JSON.parse(text)
  } catch (e) {
    return undefined
  }
}
